import { HttpInterceptorFn, HttpParams, HttpRequest } from "@angular/common/http";
import { CaseHelper } from "@shared/helpers/case.helper";
import { environment } from "@environments/environment";

function isExceptionalUrl(request: HttpRequest<unknown>): boolean {
  return [environment.alexUrl].some((url: string) => request.url.includes(url));
}

function transformQueryParams(params: HttpParams): HttpParams {
  let newParams: HttpParams = new HttpParams();

  params.keys().forEach((key: string) => {
    const snakeKey: string = CaseHelper.toSnakeKey(key);
    const values: string[] | null = params.getAll(key);

    if (values) {
      values.forEach((value: string) => {
        newParams = newParams.append(snakeKey, value);
      });
    }
  });

  return newParams;
}

export const requestTransformInterceptor: HttpInterceptorFn = (request, next) => {
  if (isExceptionalUrl(request)) return next(request);

  let transformedRequest: HttpRequest<unknown> = request;

  if (request.params.keys().length > 0) {
    transformedRequest = transformedRequest.clone({
      params: transformQueryParams(request.params),
    });
  }

  if (request.method !== "GET" && request.body) {
    transformedRequest = transformedRequest.clone({
      body: CaseHelper.toSnakeCase(request.body),
    });
  }

  return next(transformedRequest);
};
